import React from "react";
import { Link } from "react-router-dom";

export default function Breadcrumb({ items, p }) {
  return (
    <nav className="py-2 text-sm" aria-label="Breadcrumb">
      <ol className="flex items-center space-x-2">
        {items.map((item, i) => (
          <li key={i} className="flex items-center space-x-2">
            {item.href ? (
              <Link to={item.href} className={p.breadcrumbLink}>
                {item.label}
              </Link>
            ) : (
              <span className={p.breadcrumbCurrent}>{item.label}</span>
            )}
            {i < items.length - 1 && <span>/</span>}
          </li>
        ))}
      </ol>
    </nav>
  );
}
